import NutritionConfig from './NutritionConfig';

/**
 * Admin console for the "תזונת פגים" app (`PREEMIE_NUTRITION`).
 * The UI lives in the shared `NutritionConfig`; this only binds the app identity.
 */
const PreemieNutritionConfig = () => (
    <NutritionConfig
        appName="PREEMIE_NUTRITION"
        configName="nutrition-values"
        title="ניהול פורמולות ותוספים"
        appUrl="https://my.mashlom.me/main/apps/preemie-nutrition"
    />
);

export default PreemieNutritionConfig;
